import { Injectable, NgZone } from '@angular/core';
import { BrazeService } from './braze.service';
import { AnalyticsService } from 'src/smoothr-web-app-core/services/analytics/analytics.service';
import { environment } from '../../environments/environment';
import { TranslateService } from '@ngx-translate/core';

declare var cookieConsentData: any;

@Injectable({
	providedIn: 'root',
})
export class CookieConsentService {
	constructor(
		private ngZone: NgZone,
		private brazeService: BrazeService,
		private analyticsService: AnalyticsService,
		private translate: TranslateService
	) {}

	public initializeCookieConsent() {
		this.ngZone.run(() => {
			window.addEventListener('CookiebotOnLoad', () => this.handleConsent());
		});
	}

	private async initCookieConsent() {
		// const onContentLoaded = async () => {
		//     cookieConsent.run({
		//         notice_banner_type: 'simple',
		//         consent_type: 'express',
		//         palette: 'light',
		//         language: 'de',
		//         website_name: this.translate.instant('cookie_consent.title.' + environment.customerGroup),
		//         cookies_policy_url: this.translate.instant('cookie_consent.policy_url.' + environment.customerGroup),
		//     });
		// };
		// if (document.readyState === 'loading') {
		//     document.addEventListener('DOMContentLoaded', onContentLoaded);
		// } else {
		//     await onContentLoaded();
		// }
	}

	private async handleConsent() {
		await this.setAnalyticsEnabled(cookieConsentData.targeting);

		const consent = window['CookieConsent']?.consent;
		if (consent?.marketing) {
			this.enableMarketing();
			console.log('MARKETING:TRUE');
			await this.setAnalyticsEnabled(true);
		} else {
			this.disableMarketing();
			await this.setAnalyticsEnabled(false);
		}
	}

	private enableMarketing() {
		this.startBrazeInitialize();
	}

	private disableMarketing() {
		this.brazeService.disableSdk();
	}

	private startBrazeInitialize() {
		// this.brazeService.initializeService();
		// this.brazeService.logCustomEvent('AppInitialized');
		// this.brazeService.requestPushPermission();
		// this.brazeService.showInAppMessage();/
	}

	async setAnalyticsEnabled(enabled: boolean) {
		await this.analyticsService.setAnalyticsCollectionEnabled(enabled);
		this.analyticsService.loadFacebookPixel(environment.facebookPixelId);
	}
}
